import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import cv, { float } from "@techstark/opencv-js"; 

import { processImage } from "../utils/imageProcessing"; // Funcion del archivo que procesa la imagen
import { Line } from "react-chartjs-2"; // Graficos 

// Todo front
import { Col, ProgressBar } from "react-bootstrap"; 
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Ratio from "react-bootstrap/Ratio";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";

// Descarga de PDF
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import { NavDropdown } from "react-bootstrap";

type ImageProccesorProps = {
  DEBUG_DESKTOP_JUANMA: boolean;
  cutNumber?: number[];
  onFlashChange: (value: boolean) => void;
  videoConstraints: any;
  company_id: string;
  SERVER_URL: string;
  withVideoRecording: boolean;
};

//Tamaño de los chunks en ms
const CHUNCKS_MS_LENGTH = 100;
//Tiempo maximo que graba el video
const MAX_VIDEO_LENGTH_SECONDS = 10;
//Tiempo luego que termine de medir el TRC que sigue guardando
const TIEMPO_LUEGO_MEDIDA_SECONDS = 5;

//TIEMPO EN SEGUNDOS DEL COUNTER QUE TIEENE QUe CONTAR LOS MEDICOS
const TIEMPO_MAX_COUNTER = 10;

const ImageProccesor: React.FC<ImageProccesorProps> = ({
  DEBUG_DESKTOP_JUANMA,
  videoConstraints,
  cutNumber,
  company_id,
  SERVER_URL,
  withVideoRecording,
}) => {
  const webcamRef: any = useRef(null); // Es como una referencia a un componente que muestra la cámara
  const imgRef: any = React.useRef(null);
  const inRef: any = React.useRef(null);
  const [detectedPixels, setDetectedPixels] = useState(0);
  const [detectedPixelsPRES, setDetectedPixelsPRES] = useState(0);
  const alfa: number = 90;
  const beta: number = 20;
  const [cantidad_de_corte, setCantidad_de_corte] = useState(-1);
  const [tiempo_init, setTiempo_init] = useState(-1);
  const [tiempo_end, setTiempo_end] = useState(-1);
  let DEBUG = true;
  let [resultado, setResultado] = useState(0);
  let [torchonoff, setTorch] = useState(false);
  const torchState = useRef(torchonoff);
  let [counter, setCounter] = useState(TIEMPO_MAX_COUNTER);
  const [datatrc, setDatatrc] = useState<number[]>([]); // Establecer el tipo explícitamente como un array de números
  const labels: number[] = [];
  const labels2: number[] = []; // Labels del popup
  const largoarray = 500; // Largo del array del grafico que se ve en la pantalla de medicion
  let [chart, setChart] = useState(false);
  let [percentage, setPercentage] = useState(0);
  const [datacurva, setDatacurva] = useState<number[]>([]);
  const [datapix, setDatapix] = useState<number[]>([]);
  const datatrcRef = useRef<number[]>([]);
  const datapixRef = useRef<number[]>([]);
  const [timeOut, setTimeOut] = useState((1 / 60) * 1000);
  const [labelsTime, setLabelsTime] = useState<string[]>([]);

  // AGREGO ESTO PARA QUE guarde el video

  const mediaRecorderRef = useRef<MediaRecorder | null>(null); // Lo usa para grabar el video, es como un grabador de medios
  const [recordedChunks, setRecordedChunks] = React.useState<Blob[]>([]); // Es un array de Blobs que es un fragmento de video que se almacena en este array  

  // const chunksRef = useRef([]);
  const chunksRef = useRef<Blob[]>([]);
  const [recording, setRecording] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const streamRef = useRef<MediaStream | null>(null); // <- Nuevo
  const [triggerEvent, setTriggerEvent] = useState(false);

  //AGREGO ESTO PARA el modal
  const [videoURL, setVideoURL] = React.useState<string | null>(null);
  const [uploadProgress, setUploadProgress] = React.useState<number>(0);
  const [sujetoId, setSujetoId] = React.useState<string>("");
  const [fuerzaId, setFuerzaId] = React.useState<string>("");
  const [showWaitMessage, setShowWaitMessage] = useState(false);

  const [bkpCutnumb, setBkpCutnumb] = useState(cutNumber);
  
  // Agrego esto para el seleccionador de valores del clock CR
  const [valor, setValor] = useState("5"); // valor del select

  /////////// FUNCIONES //////////////

  // Muevo arriba lo del flash para qactualizarlo y que no arranque a tomar las primeras medidas
  // Torch on off
  const turnTorch = () => {
    setTorch((torchonoff) => !torchonoff);
      let track = webcamRef?.current?.stream.getVideoTracks()[0];
      if (!track) {
        console.warn("No se pudo obtener el track de video");
        return;
      }
      const capa = track.getCapabilities();
      const settings = track.getSettings();
      // console.log(capa);
      // console.log(settings);

      //JM agrego esto para poder debugear y probar en el navegador
      if (!DEBUG_DESKTOP_JUANMA) {
        if (!("zoom" in settings)) {
          return Promise.reject("Zoom is not supported by " + track.label);
        }
        track.applyConstraints({
          advanced: [
            {
            torch: !torchonoff,
              // focusMode: "continuous",
              // whitebalanceMode: "manual"
            },
          ],
        });
      }
  };
  // Creo un array deltamaño de largoarray
  for (var i = 0; i < largoarray; i++) {
    labels.push(i);
  }
  // Voy llenando el array del gráfico con los valores de la curva medidos
  function actDataTRC(pixels: number) {
    if (datatrc.length > largoarray) {
      setDatatrc([]);
    } else {
      setDatatrc((prevDatatrc) => [...prevDatatrc, pixels]);
    }
  }

  // Voy llenando el array del gráfico con los valores de la curva medidos
  function actDatapix(pixels: number) {
    if (datapix.length > largoarray) {
      setDatapix([]);
    } else {
      setDatapix((prevDatapix) => [...prevDatapix, pixels]);
    }
  }

  // Esto se usa para que capture bien los ultimos valores para la curva del popup
  useEffect(() => {
    datatrcRef.current = datatrc; // Mantiene siempre la versión más actualizada de datatrc
  }, [datatrc]);

  // Esto se usa para que capture bien los ultimos valores para la curva de pixeles
  useEffect(() => {
    datapixRef.current = datapix; // Mantiene siempre la versión más actualizada de datapix
  }, [datapix]);

  //Uso esta variable para ir calculando el contador
  const [tiempo, setTiempo] = useState<Date | null>(null);
  // const tiempoRef = useRef(tiempo);
  
  // Uso este use effect para renovar periodicamente el tiempo 
  useEffect(() => {
    const intervalo = setInterval(() => {
      setTiempo(new Date());
    }, timeOut);
  
    return () => clearInterval(intervalo);
  }, [timeOut]);
  
  /**
   *  Use effect del procesamiento de imagen CR 260525
   */
  useEffect(() => {
    if (webcamRef.current && webcamRef.current.video) {
      const video = webcamRef.current.video;
      const canvasInput = imgRef.current;
      const contextInput = canvasInput.getContext("2d");
      const canvasOutput = inRef.current;
      const contextOutput = canvasOutput.getContext("2d");

      const img = cv.imread(canvasInput);
      const imgSize = img.size();
      if (contextInput) {
        const proccessedData = processImage(img, bkpCutnumb);

        if (torchonoff || DEBUG_DESKTOP_JUANMA) {
          // Dibujar el video en el canvas
          contextInput.drawImage(video, 0, 0, imgSize.width, imgSize.height);
          setDetectedPixels(proccessedData.detectedPixels);
          setDetectedPixelsPRES(proccessedData.detectedPixels2);
          cv.imshow(inRef.current, proccessedData.image);
        } else {
          //console.log("Torchonoff is off");
          contextOutput.drawImage(video, 0, 0, imgSize.width, imgSize.height);
        }
        img.delete();
        //JM agrego la siguiente linea para que borre la memoria tambien de la imagen generada
        proccessedData.image.delete();
      }
    }
  }, [tiempo]);

  // Use effect de la medicion del tiempo 
  useEffect(() => {
    if (torchonoff) {
      setPercentage(
        (detectedPixels * 100) / (detectedPixels + detectedPixelsPRES)
      );
      // Guardar el array de segundos en el que se toma la medicion
      const now = new Date();
      const seconds = now.getSeconds();      // 0-59
      const milliseconds = now.getMilliseconds(); // 0-999
      // Crear string tipo "SS.mmm"
      const timeLabel = `${seconds.toString().padStart(2,'0')}.${milliseconds.toString().padStart(3,'0')}`;
      if (torchonoff && !showModal){
        if (labelsTime.length > 100) {
          setLabelsTime([]);
        } else {
          setLabelsTime(prev => [...prev, timeLabel]);
        };
      };
    }
    if (!chart) {
      actDataTRC(percentage);
      actDatapix(detectedPixelsPRES);
      setChart(true);
    } else {
      setChart(false);
    }

    if (percentage < beta) {
      if (counter > 0) {
        setTimeout(function () {
          setCounter(counter - 1);
        }, 1000);
      }
      //Aca estoy apretado
      setCantidad_de_corte(percentage);
      setTiempo_init(-1);
      if (!triggerEvent && counter<2){setTriggerEvent(true);
      console.log("Triger",triggerEvent);}
    } else if (percentage >= beta && cantidad_de_corte > -1) {
      //Aca el dedo se esta llenando de sangre
      if (tiempo_init == -1) {
        //Aca entra la primera vez que el detectedPixels < alfa
        setTiempo_init(Date.now());
      }
      setCantidad_de_corte(-1);
    } else if (tiempo_init > -1 && percentage > alfa) {
      setTiempo_end(Date.now());
    } else if (percentage < beta && cantidad_de_corte > -1) {
      console.log('NO tengo que entrar aca NUNCA');
    }
    if (tiempo_init > -1 && tiempo_end > -1) {
      //Aca calculo el tiempo y reinicio los contadores podria entrar en la linea luego de console.log("tiempo end =" + tiempo_end);
      if (DEBUG)
        console.log(
          "TIEMPO TRANSCURRIDO ES = " +
            (tiempo_end - tiempo_init) / 1000 +
            " segundos"
        );
      setTiempo_init(-1);
      setTiempo_end(-1);
      setCantidad_de_corte(-1);
      
      if (counter<2 && torchonoff && !showModal) { // Con el counter en <2 me aseguro que solo mida cuando pasaron los segundos del contador
        setResultado((resultado = (tiempo_end - tiempo_init) / 1000));
        setShowWaitMessage(true); // Que diga midiendo hasta que se completen los segundos
        setTimeout(() => {
          setShowWaitMessage(false); // Que una vez cumplidos los segundos vuelva a tener todo normal y muestre el popup
          // showPopUpAlert();
          setDatacurva(datatrcRef.current.slice(-100)); 
          setDatapix(datapixRef.current.slice(-100)); // Solo agrego esto para guardar la curva de pixeles
          setTriggerEvent(false);
        }, TIEMPO_LUEGO_MEDIDA_SECONDS * 1000); 
      }
      setCounter(TIEMPO_MAX_COUNTER);
    }
  }, [tiempo]);
  
  // efecto para iniciar grabación cuando se dispara evento y está listo
  useEffect(() => {
    if (isReady && triggerEvent && !recording) { // Este trigger se activa en el use Effect de la medicion del tiempo
      startRecording();
      console.log("Comienza a grabar...");
    }
    // Si querés que pare automáticamente al terminar el evento:
    if (!triggerEvent && recording) {
      stopRecording();
      console.log("Deja de grabar...");
    }
  }, [triggerEvent, isReady]);


  const handleDownload = React.useCallback(() => {
    if (chunksRef.current.length > 0) {
      const blob = new Blob(chunksRef.current, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      a.href = url;
      // a.download = "last-20-seconds.webm";
      const safeID = sujetoId.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_-]/g, "");
      const nombreArchivo = safeID ? `${safeID}-last-20-seconds.webm` : "last-20-seconds.webm";
      a.download = nombreArchivo;
      a.click();
      // window.URL.revokeObjectURL(url);
    }
  }, [recordedChunks, sujetoId]);

  const reinicarPantalla = () => {
    window.location.reload();
  };

  const rstClk = () => {
    setCounter(TIEMPO_MAX_COUNTER);
  };  

  const handleUserMedia = (stream: MediaStream) => {
    console.log('Stream obtenido:', stream);
    streamRef.current = stream;
    setIsReady(true);
  };

  const startRecording = () => {  
    const stream = webcamRef.current?.stream;
    if (!stream || !(stream instanceof MediaStream)) {
      console.error('Stream no disponible');
      return;
    }

    mediaRecorderRef.current = new MediaRecorder(stream, {
      mimeType: 'video/webm',
    });
    chunksRef.current = [];

    mediaRecorderRef.current.ondataavailable = (event) => {
      if (event.data.size > 0) {
        chunksRef.current.push(event.data);
      }
    };

    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: 'video/webm' });
      if (blob.size === 0) {
        console.error("❌ El blob está vacío");
        return;
      }
      const url = URL.createObjectURL(blob);
      console.log("✅ URL del video generado:", url);
      setVideoURL(url);        // 1. Guardás la URL
      setTimeout(() => {
        setShowModal(true);    // 2. Mostrás el modal un instante después
      }, 100); // delay leve para asegurar render
    };

    mediaRecorderRef.current.start();
    setRecording(true);
  }

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop(); // Esto activará `onstop`
      setRecording(false);
    }
  };


  const showPopUpAlert = () => {
    // handleStopCaptureClick();
    // handleVideoGenerated(); 
    setShowModal(true);
  };

  /* Aggreo parte de manejo del modal */

  // Agrego el calculo de la derivada para el gráfico del popup
  const calcularDerivada = (datos: any) => {

    if (!datos || datos.length < 2) return;

    let maxDerivada = -Infinity;
    let indexMax = -1;
    for (let i = 1; i < datos.length; i++) {
      const derivada = datos[i] - datos[i - 1];
      if (derivada > maxDerivada) {
        maxDerivada = derivada;
        indexMax = i;
      }
    }
    return [maxDerivada, indexMax];
  }

  // Gráfico del popup
  const options2 = {
    animation: {
      duration: 0, // establece la duración de la animación a 0 para desactivarla
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "[%]",
        },
      },
    },
  };

  // Solo para graficar despues los pixeles en el reporte
  const options3 = {
    animation: {
      duration: 0, // establece la duración de la animación a 0 para desactivarla
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Pixeles",
        },
      },
    },
  };

  // Labels para el gráfico del popup
  for (var i = 0; i < 100; i++) {
    labels2.push(i);
  }

  const [maxDerivada, indexMax] = calcularDerivada(datacurva) || [];
  const data2 = {
    labels: labels2,
    datasets: [
      {
        label: "Curva TRC",
        data: datacurva,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        borderColor: "rgba(255, 99, 132, 1)",
        pointRadius: 0, // ocultar puntos normales
        fill: false,
      },
      {
        label: "Máxima derivada",
        data: labels2.map((_, i) => (i === indexMax ? datacurva[i] : null)),
        backgroundColor: "blue",
        pointRadius: 6, // más grande para destacarlo
        pointHoverRadius: 8,
        showLine: false, // solo punto, sin línea
      },
    ],
  };

  // Curva pixeles 
  const data3 = {
    labels: labels2,
    datasets: [
      {
        label: "Curva Pixeles",
        data: datapix,
        backgroundColor: "rgba(0, 255, 255, 0.5)",
        borderColor: "rgba(0, 255, 255, 0.5)",
        pointRadius: 0, // ocultar puntos normales
        fill: false,
      },
    ],
  };
  
  /**
   * fucion que se llama cuando se cierra el modal
   * @param param0
   */
  const handleCloseModal = () => {
    setShowModal(false);
  };

  /*END  Agreo parte de manejo del modal */
  
  // Configuracion Chart JS
  const options = {
    animation: {
      duration: 0, // establece la duración de la animación a 0 para desactivarla
    },
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: "[%]",
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Curva TRC",
        data: datatrc,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  const handleDownloadPDF = async () => {
    const input = document.getElementById("curva-container");
    const inputpix = document.getElementById("curva-pixeles");
    if (!input) return;

    // ---- Fecha con hora, minutos y segundos ----
    const fechaActual = new Date().toLocaleString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).replace(",", "");

    const imgWidth = 190;

    // ---- Función para capturar un canvas ----
    const capturarCanvas = async (element: HTMLElement) => {
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      return { imgData, imgHeight };
    };

    // ---- Capturar primer gráfico (curva-container) ----
    const { imgData: imgData1, imgHeight: imgHeight1 } = await capturarCanvas(input);

    const pdf = new jsPDF("p", "mm", "a4");
    const idTexto = sujetoId.trim().length > 0 ? sujetoId : "Desconocido";

    // Encabezado
    pdf.setFontSize(16);
    pdf.text(`ID: ${idTexto}`, 10, 10);
    pdf.text(`Fecha: ${fechaActual}`, 10, 16);

    // Primer gráfico
    pdf.addImage(imgData1, "PNG", 10, 20, imgWidth, imgHeight1);

    let yPos = imgHeight1 + 35;

    // ---- Valores crudos del primer gráfico ----
    pdf.setFontSize(12);
    const datosRedondeados1 = datacurva.map((valor) => valor.toFixed(2));
    const texto1 = `Valores crudos (TRC): \n${datosRedondeados1.join(", ")}`;
    const textoFormateado1 = pdf.splitTextToSize(texto1, 180);
    pdf.text(textoFormateado1, 10, yPos);
    yPos += textoFormateado1.length * 7 + 20;

    // ---- Resultados finales (solo en la hoja del primer gráfico) ----
    pdf.text(`TRC: ${resultado}`, 10, yPos + 10);
    pdf.text(`Valor de corte: ${bkpCutnumb ? bkpCutnumb[1] : ""}`, 10, yPos + 20);
    pdf.text(`Máxima derivada: ${maxDerivada.toFixed(2)}`, 10, yPos + 30);
    pdf.text(`Posición del dato de máxima derivada: ${indexMax}`, 10, yPos + 40);

    // ---- Segunda hoja para el gráfico de pixeles ----
    if (inputpix) {
      const { imgData: imgData2, imgHeight: imgHeight2 } = await capturarCanvas(inputpix);
      pdf.addPage(); // nueva hoja para el segundo gráfico
      pdf.setFontSize(16);
      pdf.text(`ID: ${idTexto}`, 10, 10);
      pdf.text(`Fecha: ${fechaActual}`, 10, 16);

      pdf.addImage(imgData2, "PNG", 10, 25, imgWidth, imgHeight2);

      let yPos2 = imgHeight2 + 40;

      // Valores crudos del segundo gráfico
      pdf.setFontSize(10); // tamaño más pequeño para ahorrar espacio
      const datosRedondeados2 = datapix.map((valor) => Math.round(valor));
      const texto2 = `Valores crudos (pixeles): ${datosRedondeados2.join(", ")}`;
      const textoFormateado2 = pdf.splitTextToSize(texto2, 180);
      pdf.text(textoFormateado2, 10, yPos2);

      // ---- Mostrar tu array labelsTime después de los datos del segundo gráfico ----
      if (labelsTime && labelsTime.length > 0) {
        yPos2 += textoFormateado2.length * 5 + 5; // menos espacio vertical
        pdf.setFontSize(9); // fuente más pequeña para labelsTime
        const textoLabels = `LabelsTime: ${labelsTime.join(", ")}`;
        const textoFormateadoLabels = pdf.splitTextToSize(textoLabels, 180);
        pdf.text(textoFormateadoLabels, 10, yPos2);
      }
    }

    // ---- Guardar PDF ----
    pdf.save(`Curva_${idTexto}.pdf`);
  };



  // Modificacion del factor de corte
    useEffect(() => {
    if (bkpCutnumb) {
      console.log("finalResults actualizado:", bkpCutnumb);
    }
  }, [bkpCutnumb]);

  const handleDecrement = () => {
    if (bkpCutnumb) {
      let res2 = [
        bkpCutnumb[0] - 1,
        bkpCutnumb[1] - 1,
        bkpCutnumb[2],
      ];
      setBkpCutnumb(res2);
    }
  };

  const handleIncrement = () => {
    if (bkpCutnumb) {
      let res3 = [
        bkpCutnumb[0] + 1,
        bkpCutnumb[1] + 1,
        bkpCutnumb[2],
      ];
      setBkpCutnumb(res3);
    }
  };

  const handleValor = (v: any) => {
    setValor(v);
    setCounter(parseInt(v)); // Aca asigna los avlores al counter
  };


  return (
    <>
      <Webcam
        ref={webcamRef}
        onUserMedia={handleUserMedia}
        imageSmoothing={false}
        screenshotFormat="image/jpeg" // define el formato cuando se captura una imagen con webcamRef.current.getScreenshot()
        style={{ position: "absolute", opacity: 0, width: 200, height: 200 }} // Video oculto
        videoConstraints={videoConstraints} // Caracteristicas del video, camara, tamaño imagen etc.
        audio={false}
        screenshotQuality={1} // Calidad máxima de las capturas
      />

      <canvas style={{ width: "1px", height: "1px" }} ref={imgRef} />

      {/* Acá pongo el menu despegable para cambiar el valor delcontador OJO */}
      {/* <NavDropdown title={`Config (${valor})`} align="end">
        <NavDropdown.Item onClick={() => handleValor("5")}>
          Valor 5
        </NavDropdown.Item>
        <NavDropdown.Item onClick={() => handleValor("10")}>
          Valor 10
        </NavDropdown.Item>
        <NavDropdown.Item onClick={() => handleValor("15")}>
          Valor 15
        </NavDropdown.Item>
      </NavDropdown> */}

      <div className="d-flex justify-content-end px-3 pt-2">
        <NavDropdown
          // title={<span className="dropdown-button-like">Config ({counter})</span>}
          title={
            <Button variant="primary" size="sm">
              TEMPORIZADOR ({counter})
            </Button>
          }
          id="config-dropdown"
          align="end"
          menuVariant="light"
        >
          <NavDropdown.Item onClick={() => setCounter(5)}>
            Valor 5
          </NavDropdown.Item>
          <NavDropdown.Item onClick={() => setCounter(10)}>
            Valor 10
          </NavDropdown.Item>
          <NavDropdown.Item onClick={() => setCounter(15)}>
            Valor 15
          </NavDropdown.Item>
        </NavDropdown>
      </div>

      <Row className="camera">
        <Col className="col-12">
          <Ratio aspectRatio="1x1" style={{ maxWidth: "280px", margin: "0 auto" }}>
            <canvas ref={inRef} style={{ width: "100%", height: "100%" }} />
          </Ratio>
          {!torchonoff && (
            <div className="counter-overlay flash-message">
              ENCENDER EL FLASH
            </div>
          )}
          {torchonoff && counter > 0 && (
            <div
              className={`counter-overlay ${
                showWaitMessage && withVideoRecording ? "wait-message" : ""
              }`}
            >
              {showWaitMessage && withVideoRecording ? "MIDIENDO" : counter}
            </div>
          )}
        </Col>
      </Row>
      <Row className="mt-2 mb-1">
        <Col>
          <div className="d-grid gap-2">
            <Button variant="primary" size="lg" onClick={turnTorch}>
              LED ON/OFF
            </Button>
          </div>
        </Col>
      </Row>
      <Row className="mt-1 white_text mb-1">
        <Col>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <h4 className="white_text m-0">Corte {bkpCutnumb?.at(1)}</h4>
            <div className="d-flex gap-2">
              <Button variant="primary" onClick={handleDecrement}>-</Button>
              <Button variant="primary" onClick={handleIncrement}>+</Button>
            </div>
          </div>
        </Col>
        <Col>
          <span> El TRC es de: {resultado} seg. </span>
        </Col>
      </Row>

      <Row className="blue_over_green_text m-0 p-0">
        <Col className="col-12 white_background p-0 m-0">
          <Line options={options} data={data} />
        </Col>
      </Row>
      {/* Seccion de footer donde estan los botones para tomar imagen etc */}
      <Container className="fixed-bottom mb-2 mr-1">
        <Row className="">
          <Col>
            <div className="d-grid gap-2">
              <Button variant="primary" size="lg" onClick={reinicarPantalla}>
                Reiniciar
              </Button>
            </div>
          </Col>
          {/* //ESTE CODIDOG ERA PARA PROBAR EL  POPUP */}

          <Col>
            <div className="d-grid gap-2">
              <Button variant="primary" size="lg" onClick={showPopUpAlert}>
                Show Popup
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal} container={document.body}>
        <Modal.Header closeButton>
          <Modal.Title>Medicion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              {withVideoRecording && videoURL ? (
                <Ratio aspectRatio="1x1">
                  <video
                    controls
                    src={videoURL}
                    typeof="video/webm"
                    onLoadedData={() => console.log("✅ Video cargado correctamente")}
                    onError={(e) => {
                      console.error("❌ Error cargando video", e);
                      alert("No se pudo cargar el video grabado.");
                    }}
                    onCanPlay={() => console.log("🎬 Video listo para reproducirse")}
                    onPlay={() => console.log("▶ Reproducción iniciada")}
                    onPause={() => console.log("⏸ Reproducción pausada")}
                  />
                </Ratio>
              ) : (
                <div className="text-center p-4">
                  <p>No hay video para mostrar aún.</p>
                </div>
              )}

          <Form className="mt-4">
            <Row>
              <Col>
                <Row>
                  <Col>
                    <Form.Label className="white_text">TRC</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      readOnly={true}
                      value={resultado}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col>
                    <Form.Label column="lg" className="white_text">
                      Valor Corte{" "}
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      readOnly={true}
                      value={bkpCutnumb ? bkpCutnumb[1] : ""}
                    />
                  </Col>
                </Row>
                {/* <Row className="mt-2">
                  {/* <Col xs="auto"> 
                    <Form.Label className="white_text">Fuerza [g.]</Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Fuerza en gramos"
                      value={fuerzaId} 
                      onChange={(e) => setFuerzaId(e.target.value)} 
                    />
                  {/* </Col> 
                </Row> */}
              </Col>
            </Row>

            <Row>
              <Col>
                <Row>
                  <Col className="col-12">
                    <Form.Label className="white_text">Sujeto ID</Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Indentificador Sujeto"
                      value={sujetoId} 
                      onChange={(e) => setSujetoId(e.target.value)} 
                      isInvalid={sujetoId.length === 0}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>

          <div id="curva-container" className="mt-4">
            <Col className="col-12 white_background">
              {" "}
              <Line options={options2} data={data2} />
            </Col>
          </div>

          <div id="curva-pixeles" className="mt-4">
            <Col className="col-12 white_background">
              {" "}
              <Line options={options3} data={data3} />
            </Col>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Reiniciar
          </Button>
          <Button 
            variant="success" 
            onClick={handleDownload}
            disabled={sujetoId.length == 0}
          >
            Download
          </Button>
          <Button 
            variant="success" 
            onClick={handleDownloadPDF}
            disabled={sujetoId.length == 0}
          >
            Descargar Curva PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ImageProccesor;


// branch en base versionmedicos